import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { TYPE } from 'app/config/prescription_content';
// utils
import { isBefore, isAfter, startOfDay, endOfDay, getDate } from 'date-fns';
import generateDates from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/generateDates';
import setTimePerShift from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/setTimePerShift';
import dateFormat from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/dateFormat';
const schedulePerMonthPerShift = function (padPrescription, pad) {
  const {
    //padPrescriptionId,
    //instruction,
    padPrescriptionSuggestionScheduling
    //
  } = padPrescription;

  // ***************************************************************************
  //                   GET PAD_PRESCRIPTION INFORMATION
  // ***************************************************************************

  const { TIMES_PER } = CALENDAR_TYPE;
  //const cPadPrescription = await padPrescription.getByID(padPrescriptionId);

  const calendarType = TIMES_PER;
  const { /* padId, */ description, type } = padPrescription;

  // ***************************************************************************
  //                   GET PAD INFORMATION
  // ***************************************************************************

  let { startDate, endDate } = pad;

  const padStartDate = startOfDay(startDate);
  const padEndDate = endOfDay(endDate);

  // ***************************************************************************
  //                           VALIDATE PAD_PRESCRIPTION TYPE
  // ***************************************************************************

  // FIXME avaliar necessidade dessa verificação

  const { SUSPENDED } = TYPE;

  const isPadPrescriptionSuspended = type === SUSPENDED;

  if (isPadPrescriptionSuspended) return;

  // ***************************************************************************
  //             FIND PRESCRIPTION_CONTENT FROM PAD_PRESCRIPTION ID
  // ***************************************************************************

  //const pContent = await prescriptionContent.getOne({ padPrescriptionId });

  // ***************************************************************************
  //                   DATES TO SCHEDULE PRESCRIPTION
  // ***************************************************************************

  const now = new Date();
  const startDateToday = startOfDay(now);
  const {
    period,
    continuousUse,
    once
    // frequencyTypeId,
    // frequencyAmount,
    // frequency,
    // timeStart,
    // timeEnd,
  } = padPrescription;

  let dates = generateDates({
    period,
    continuousUse,
    once,
    startDate: startDateToday,
    endDate: padEndDate
  });

  dates = [...dates]
    // Removes date that are later than the padEndDate of Pad
    .filter(startDateTime => !isAfter(startOfDay(startDateTime), padEndDate))
    // Removes date that are before than the padStartDate of Pad
    .filter(startDateTime => !isBefore(startOfDay(startDateTime), padStartDate));

  // ***************************************************************************
  //                        SCHEDULE PRESCRIPTION CALENDAR
  // ***************************************************************************

  //const prescriptionContentId = pContent.id;
  let perMonthPerShiftList = [];
  // eslint-disable-next-line
  for (let date of dates) {
    // eslint-disable-next-line
    for (let padPrescriptionSuggestion of padPrescriptionSuggestionScheduling) {
      const { applicationDate, shift: shiftId } = padPrescriptionSuggestion;

      if (getDate(date) === getDate(applicationDate)) {
        const administrateDate = setTimePerShift(date, shiftId);

        const insert = {
          //prescriptionContentId,
          calendarType,
          administrateDate,
          shiftId,
          // administrateVisitationId,
          // aplicationDate,
          // aplicationVisitationId,
          // digitalSignature,
          // latitude,
          // longitude,
          description
        };
        perMonthPerShiftList.push(insert);
      }
    }
  }
  return dateFormat(perMonthPerShiftList);
};

export default schedulePerMonthPerShift;
